/* eslint-disable no-param-reassign */ /* eslint-disable @typescript-eslint/no-use-before-define */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { mapValues, forEach } from "./lodash";
import { _langList, localLangMap } from "../const/lang";
import { setCookie, getCookie } from "./cookie";
import { debugInfo, isDebugConsole } from "./log";
import { g, isBrowser } from "../const/globalThis";
export * from "./log";
/** 获取当前环境os的lang */ export var getOSLang = function() {
    var _g__GATEWAY_PF_userPreference, _g__GATEWAY_PF;
    return (_g__GATEWAY_PF = g._GATEWAY_PF) === null || _g__GATEWAY_PF === void 0 ? void 0 : (_g__GATEWAY_PF_userPreference = _g__GATEWAY_PF.userPreference) === null || _g__GATEWAY_PF_userPreference === void 0 ? void 0 : _g__GATEWAY_PF_userPreference.lang;
};
export var getLangProfile = function() {
    var _g___PANDA, _g___PANDA1;
    var cookieKey = ((_g___PANDA = g.__PANDA) === null || _g___PANDA === void 0 ? void 0 : _g___PANDA.cookieKey) || "x-hng";
    var _ref = _sliced_to_array(function() {
        var _g___PANDA;
        if (g.__PANDA_LANG) {
            return [
                "env",
                g.__PANDA_LANG
            ];
        }
        var searchLang = getSearchLang();
        if (searchLang) {
            return [
                "search",
                searchLang
            ];
        }
        if (getOSLang()) {
            return [
                "os",
                getOSLang()
            ];
        }
        // 获取CDN给予的cookieKey, 如果没有默认走x-hng
        var isXhrg = cookieKey === "x-hng";
        // eslint-disable-next-line no-negated-condition
        var customLang = !isXhrg ? getCookie(cookieKey) : undefined;
        if (customLang) {
            return [
                "cookie",
                customLang
            ];
        }
        // eslint-disable-next-line prefer-const
        var xhngLang = isXhrg && isBrowser ? getXhngCookieLang() : null;
        if (xhngLang) {
            return [
                "cookie",
                xhngLang
            ];
        }
        if ((_g___PANDA = g.__PANDA) === null || _g___PANDA === void 0 ? void 0 : _g___PANDA.defaultLang) {
            return [
                "default",
                g.__PANDA.defaultLang
            ];
        }
        var navigatorLang = getNavigatorLang();
        if (navigatorLang) {
            return [
                "navigator",
                navigatorLang
            ];
        }
        return [
            "fallback",
            "zh-CN"
        ];
    }(), 2), type = _ref[0], envLang = _ref[1];
    var usedLang = typeof envLang === "string" ? formatLang(envLang) : "zh-CN";
    // 如果全局设置的langList（允许语种），则最终会受限制
    var supportlangList = ((_g___PANDA1 = g.__PANDA) === null || _g___PANDA1 === void 0 ? void 0 : _g___PANDA1.langList) || null;
    if (supportlangList && !supportlangList.includes(usedLang)) {
        usedLang = supportlangList[0];
    }
    var langProfile = {
        langList: supportlangList,
        envLang: envLang,
        lang: usedLang,
        type: type,
        cookieKey: cookieKey
    };
    isDebugConsole() && debugInfo("langProfile >>> lang: ".concat(langProfile.lang, " type: ").concat(langProfile.type, " cookieKey: ").concat(langProfile.cookieKey, " envLang: ").concat(langProfile.envLang, " langList: ").concat(supportlangList ? supportlangList.join(",") : "null"));
    return langProfile;
};
/**
 * 获取当前的语种
 */ export var getLang = function() {
    return getLangProfile().lang;
};
/**
 * 语种格式转换：en-US，en_US, en_us, en 全部格式化为en-US
 * @param {string} locale 语种
 */ export var formatLang = function(locale) {
    // 如果格式不正确直接返回当前的语种防止处理报错
    if (typeof locale !== "string") return getLang();
    // 替换底线为短横线并转换为小写
    var slocale = locale.replace("_", "-").toLowerCase();
    locale = slocale;
    var lang = slocale;
    var region = "";
    // 处理短横线
    if (slocale.includes("-")) {
        var _region;
        var ref;
        ref = _sliced_to_array(slocale.split("-"), 2), lang = ref[0], region = ref[1], ref;
        locale = "".concat(lang, "-").concat((_region = region) === null || _region === void 0 ? void 0 : _region.toUpperCase()); // 确保区域部分大写
    }
    // 查找符合的语言
    var theLang = _langList.find(function(item) {
        return item.v === locale || (typeof item.s === "string" ? item.s === slocale : item.s.includes(slocale));
    });
    // 明确找到返回对应的语种
    if (theLang) {
        return theLang.v;
    }
    // 通用语种
    if (localLangMap[lang]) return localLangMap[lang];
    return locale;
};
/**
 * 获取当前的语种
 * @deprecated 请使用getLang
 */ export var getCurrentLang = getLang;
/**
 * 获取当前的语种详情
 * @deprecated 请使用getLangProfile
 */ export var getCurrentLangProfile = getLangProfile;
export function getRandomKey() {
    return Math.random().toString(36).slice(2);
}
export function inLang(lang) {
    /**
   * 是否在支持范围，0.3.3后改为宽泛的判断，不在以当前支持语种作为判断依据
   * !!langList.find((item) => item.value === lang)
   */ return lang && /^[a-z]{2}(-[a-zA-Z0-9]{1,4})?$/.test(lang);
}
export function convertPandaI18nFormatToLocalResource(pandaString) {
    var pandaFormat = {};
    forEach(pandaString, function(v, k) {
        pandaFormat[formatLang(k)] = mapValues(v.copyList, function(item) {
            return item.content;
        });
    });
    return pandaFormat;
}
/** 如果非x-hng则设置值，x-hng只处理lang部分 */ export function setCookieLang(lang) {
    if (!isBrowser) return;
    if (g.__PANDA.cookieKey === "x-hng") {
        setI18nCookie("lang", lang);
    } else {
        setCookie(g.__PANDA.cookieKey, lang);
    }
}
export function setI18nCookie(type, value) {
    var newUrlP = new URLSearchParams(getCookie("x-hng"));
    newUrlP.set(type, value);
    newUrlP.set("domain", location.hostname);
    // 为了确保lang存在,如没有lang的值设置一个当前的环境语种
    if (newUrlP.get("lang") === null) {
        newUrlP.set("lang", getLang());
    }
    setCookie("x-hng", newUrlP.toString());
}
/** 如果非x-hng则返回值，x-hng则返回lang部分的值, 实际可能会返回null */ export function getXhngCookieLang() {
    return new URLSearchParams(getCookie("x-hng")).get("lang");
}
/** 获取浏览器中指定的语种 */ export function getNavigatorLang() {
    if (typeof navigator !== "undefined" && navigator.language && navigator.userAgent) {
        var navigatorLanguage = navigator.language;
        // Compatible with dingding
        if (navigator.userAgent.includes("DingTalk")) {
            var _lanuageMatch;
            var lanuageMatch = navigator.userAgent.match(/language\/([a-zA-Z-]+)/);
            if (lanuageMatch && ((_lanuageMatch = lanuageMatch) === null || _lanuageMatch === void 0 ? void 0 : _lanuageMatch[1])) {
                navigatorLanguage = lanuageMatch[1];
            }
        }
        var formatedLang = formatLang(navigatorLanguage);
        if (inLang(formatedLang)) {
            return formatedLang;
        }
        return navigator.languages.find(function(_lang) {
            return inLang(_lang);
        }) || "zh-CN";
    }
    return "zh-CN";
}
export function langToShortLang(lang) {
    var theLang = _langList.find(function(item) {
        return item.v === lang;
    });
    if (theLang) {
        return typeof theLang.s === "string" ? theLang.s : theLang.s[0];
    }
    return lang.split("-")[0].toLocaleLowerCase();
}
/** 强制设置环境语种，使用环境变量作为当前域的语种，优先级高，请勿随意使用！ */ export function setEnvLang(lang) {
    g.__PANDA_LANG = lang;
}
/** 设置当前所有$i18n实例的语种 */ export function setAllI18nLang(lang) {
    Object.values(g.__PANDA_INSTANCES).forEach(function(instance) {
        var $i18n = instance.$i18n || null;
        // 未设置了自定义语种的情况下才会设置
        if ($i18n && !$i18n.customLang) {
            $i18n.currentLang = lang;
        }
    });
}
/** 将当前的判断语种兼容到cookie中(不支持非x-hng方案) */ export function keepCookieLang() {
    var lang = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getLang();
    if (g.__PANDA.cookieKey === "x-hng" && !getCookie("x-hng")) {
        debugInfo("set cookie lang: ".concat(lang));
        setCookieLang(lang);
    }
}
export function isRTL(lang) {
    if (isBrowser && document.dir === "rtl") {
        return true;
    }
    if (lang) {
        // 未考虑当前未支持的巴什基尔语(ba)、库尔德语(ckb)、巴赫地语(bal)
        return [
            "ar",
            "he",
            "iw",
            "fa",
            "ur"
        ].includes(lang.split("-")[0]);
    }
    return false;
}
function getSearchLang() {
    if (typeof location !== "undefined" && location.search && isBrowser) {
        var urlParams = new URLSearchParams(location.search);
        var searchLang = urlParams.get("lang");
        if (searchLang) {
            var formatedLang = formatLang(searchLang);
            if (inLang(formatedLang)) {
                return formatedLang;
            }
        }
    }
    return null;
}
